import { render } from "./ReportResultTable.vue?vue&type=template&id=5f0f74fb&scoped=true"
import script from "./ReportResultTable.vue?vue&type=script&lang=js"
export * from "./ReportResultTable.vue?vue&type=script&lang=js"

import "./ReportResultTable.vue?vue&type=style&index=0&id=5f0f74fb&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0f74fb"]])

export default __exports__